@if (component()?.hotspots?.length) {
<div class="hotspot-wrapper"
     [class.cursor-pointer]="targetUrl()?.length"
     [class.pos-relative]="component().hotspots.length"
     [class.on-hover]="component().hotspotsVisibility === visibility.Hover"
     [class.is-hover]="isHover()"
     [class.is-cms]="canEdit"
     (click)="navigateToUrl($event)">
    <!-- hotpoints -->
    @for (hotspot of component().hotspots; track $index) {
    @if (isExists(hotspot)) {
    <div class="hotspot"
         [class.swiper-no-swiping]="canEdit"
         [class.no-data]="!(!!hotspot.product || !!hotspot.content)"
         [style.--hotspot-top.%]="hotspot?.top || 0"
         [style.--hotspot-left.%]="hotspot?.left || 0"
         [style.--hotspot-color]="'#fff'"
         (offClick)="close()"
         [offClickOff]="!isOpen"
         offClickFilter=".hotspot, .hotspot-content-wrapper"
         cdkDrag
         [cdkDragDisabled]="!canEdit"
         cdkDragBoundary=".hotspot-wrapper"
         (cdkDragStarted)="handleDragStarted()"
         (cdkDragMoved)="handleDragMoved()"
         (cdkDragEnded)="handleDragEnded($event, hotspot)"
         (click)="handleHotspotEnter(hotspotRef, hotspot, $index)"
         #hotspotRef>
    </div>
    }
    }
    <!-- content -->
    <ng-container [ngTemplateOutlet]="content" />
</div>
} @else {
<ng-container [ngTemplateOutlet]="content" />
}

<ng-template #content>
    <ng-content />
</ng-template>

<ng-template #hotspotTemplate
             let-data
             let-index="index">
    <div class="hotspot-content-wrapper"
         (mouseenter)="clearClosingTimeoutId()">
        @if (data.content || data.product) {
        @if (isOpen) {
        <button class="hotspot-close col-1 bg-col-12"
                type="button"
                (click)="close()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
        }
        <cms-hotspots-product [modelId]="data.product"
                              [hotspot]="data"
                              (close)="close()" />
        }
    </div>
</ng-template>